import { createRootRoute, Outlet } from "@tanstack/react-router";
import { LayoutProvider } from "@/modules/chat/layout/LayoutProvider";
import { ChatStoreProvider } from "@/modules/chat/stores";

export const Route = createRootRoute({
  component: RootLayout,
});

function RootLayout() {
  return (
    <ChatStoreProvider>
      <LayoutProvider>
        <Outlet />
      </LayoutProvider>
    </ChatStoreProvider>
  );
}
